import { Outlet, useLoaderData, useRouteLoaderData } from "react-router-dom";
import { User } from "../services/user/userModel";
import { Organization } from "../services/organization/organizationModel";
import ProShell from "../components/shell/ProShell";

const OrganizationArea = () => {
  const { loggedUser } = useRouteLoaderData("logged-user") as {
    loggedUser?: User;
  };
  const { organization } = useLoaderData() as { organization: Organization };

  return (
    <ProShell loggedUser={loggedUser} organization={organization}>
      <Outlet />
    </ProShell>
  );
};

export default OrganizationArea;
